function EmptyIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="M8 10h8M8 14h5" />
    </svg>
  );
}

export default function EmptyState({ icon, title, subtitle, children }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon || <EmptyIcon />}</div>
      {title ? <div className="empty-title">{title}</div> : null}
      {subtitle ? <div className="empty-sub">{subtitle}</div> : null}
      {children}
    </div>
  );
}
